import React from "react";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { 
  LmsLoanDetailsTable, 
  LmsLoanPropertyTable, 
  LmsLoanCommentsTable,
  LmsLoanDetailsEntitiesTable, 
} from "../ui/LmsSharedTables";
import LmsTabPages from "../ui/LmsTabPages";
import { LmsLoanReviewApplicationForm } from "../ui/LmsSharedForms";

const LmsLoanApplicationTabPages = ({ id }) => {
  const tabPages = {
    Details: (
      <LmsLoanDetailsTable
        overrideDefaultTableProps={{
          apiSuffix: `voting/loan-review/list-loan-details/${id}`,
          actionButtons: [
            { action: "edit", path: "loandetails" },
            "export",
          ],
          onClickPath: "loandetails"
        }}
      />
    ),
    Properties: <LmsLoanPropertyTable loanId={id}/>,
    Entities: <LmsLoanDetailsEntitiesTable loanDetailsId={id} suffix={`loans/entities/${id}`} />,
    Comments: <LmsLoanCommentsTable loanId={id}/>,
    Condition: <LmsTable actionButtons={["export"]} apiSuffix={`loandetails/conditions/${id}`}/>
  };

  return <LmsTabPages tabPages={tabPages}/>;
};

const FundPollingEditPage = ({ id }) => {
  return <React.Fragment>
    <LmsLoanReviewApplicationForm loanId={id} />
    <LmsTable apiSuffix={`voting/loan-review/list-loan-docs/${id}`} title="Documents" skipFilter/>
    <LmsTable apiSuffix={`voting/fund-polling-results/${id}`} title="Members Vote" skipFilter skipClick/>
    <LmsLoanApplicationTabPages id={id}/>
  </React.Fragment>;
};

const FundPollingMainPage = () => {
  return <LmsTable actionButtons={["edit", "export"]} apiSuffix="voting/list-fund-polling"/>;
};

const LmsVotingFundPolling = ({ ...props }) => {
  const { params = {}, history } = props;
  const { isEdit, isMainPage, isActionAllowed, id } = useParseRouteActions(params, ["edit"]);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <FundPollingMainPage/>}
    {isEdit && <FundPollingEditPage id={id} />}
  </React.Fragment>;
};

export default LmsVotingFundPolling;